import { lazy } from 'react';
import { defineBlock, smartProps, useInspectorControl, BlockWrapper, useEditor } from '@smartfire/js-block-engine';
import { useMediaQuery } from '@mui/material';
import clsx from 'clsx';
import style from './style.module.scss';

const Inspector = lazy(() => import('./inspector.js'));

function Block({ height, mobileHeight, separator }) {
    useInspectorControl(Inspector);
    const { isEditing } = useEditor();
    const isMobile = useMediaQuery('(max-width: ' + style.mobileBreakpoint + ')');
    const spacerHeight = isMobile ? mobileHeight : height;

    return (
        <BlockWrapper.Div
            className={clsx(style.block, separator && style.separator, isEditing ? style.admin : style.frontend)}
            style={{ height: spacerHeight + 'px' }}
        />
    );
}

export default defineBlock({
    Block,
    smartProps: {
        height: smartProps.string.withDefault(50),
        mobileHeight: smartProps.string.withDefault(30),
        separator: smartProps.bool.withDefault(false),
    },
    setup: {
        title: 'Spacer',
    },
});
